// extracted by mini-css-extract-plugin
module.exports = {"Root":"tests_Root__1GMkR"};